import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import { Color } from 'core';

const dotPulse = keyframes`
  0%, 100% { opacity: 0.3; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.2); }
`;

interface LoadingDotsProps {
  size?: 'small' | 'medium' | 'large';
}

const LoadingDots = ({ size = 'medium' }: LoadingDotsProps) => {
  return (
    <Container size={size}>
      <Dot delay="0s" size={size} />
      <Dot delay="0.3s" size={size} />
      <Dot delay="0.6s" size={size} />
    </Container>
  );
};

export default LoadingDots;

const Container = styled.div<{ size: string }>`
  display: flex;
  gap: ${(props) => {
    switch (props.size) {
      case 'small':
        return '4px';
      case 'large':
        return '12px';
      default:
        return '8px';
    }
  }};
  align-items: center;
`;

const Dot = styled.div<{ delay: string; size: string }>`
  width: ${(props) => {
    switch (props.size) {
      case 'small':
        return '4px';
      case 'large':
        return '12px';
      default:
        return '8px';
    }
  }};
  height: ${(props) => {
    switch (props.size) {
      case 'small':
        return '4px';
      case 'large':
        return '12px';
      default:
        return '8px';
    }
  }};
  border-radius: 50%;
  background: ${Color.primaryBlue};
  ${css`
    animation: ${dotPulse} 1.5s infinite;
  `}
  animation-delay: ${(props) => props.delay};
`;